import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError' // Added import
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { UserDetail } from 'types/api'
import { BaseParams } from 'types/utils'

export function useCreateClient() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()
  const onError = useOnError() // Added useOnError
  const navigate = useNavigate()

  async function createClient({ body }: BaseParams<UserDetail, 'POST'>) {
    const res = await apiClient.post<UserDetail>(SNA_PREFIX + `users/`, body)
    return res.data
  }

  return useMutation({
    mutationFn: createClient,
    onSuccess: () => {
      toast.success({ message: t('clientCreated') })
      queryClient.invalidateQueries({ queryKey: ['client'] })
      navigate('/admin/landlords')
    },
    onError // Updated to use useOnError
  })
}
